<template>
  <div class="report-service-workreport">
<!--    工作报表-客服-->
    <transition name="fade-transform" mode="out-in">
    <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'report-service-workreport',
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
.report-service-workreport{

  width: 100%;
}
</style>
